import { collectNumbers, numericExtent, vwapSeries } from "../utils";
const VWAP = {
    name: "VWAP",
    compute: (bars, anchor = "session", showBands = true, multiplier = 1) => vwapSeries(bars, anchor, showBands, multiplier),
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default VWAP;
